// Shtetet e lejuara (BE/EEA + UK + Norvegji + Zvicër), me flamur dhe prefiks telefoni.
export const COUNTRIES = [
  { name: "Austri", flag: "🇦🇹", dial: "+43" },
  { name: "Belgjikë", flag: "🇧🇪", dial: "+32" },
  { name: "Bullgari", flag: "🇧🇬", dial: "+359" },
  { name: "Kroaci", flag: "🇭🇷", dial: "+385" },
  { name: "Qipro", flag: "🇨🇾", dial: "+357" },
  { name: "Çeki", flag: "🇨🇿", dial: "+420" },
  { name: "Danimarkë", flag: "🇩🇰", dial: "+45" },
  { name: "Estoni", flag: "🇪🇪", dial: "+372" },
  { name: "Finlandë", flag: "🇫🇮", dial: "+358" },
  { name: "Francë", flag: "🇫🇷", dial: "+33" },
  { name: "Gjermani", flag: "🇩🇪", dial: "+49" },
  { name: "Greqi", flag: "🇬🇷", dial: "+30" },
  { name: "Hungari", flag: "🇭🇺", dial: "+36" },
  { name: "Irlandë", flag: "🇮🇪", dial: "+353" },
  { name: "Itali", flag: "🇮🇹", dial: "+39" },
  { name: "Letoni", flag: "🇱🇻", dial: "+371" },
  { name: "Lituani", flag: "🇱🇹", dial: "+370" },
  { name: "Luksemburg", flag: "🇱🇺", dial: "+352" },
  { name: "Maltë", flag: "🇲🇹", dial: "+356" },
  { name: "Holandë", flag: "🇳🇱", dial: "+31" },
  { name: "Poloni", flag: "🇵🇱", dial: "+48" },
  { name: "Portugali", flag: "🇵🇹", dial: "+351" },
  { name: "Rumani", flag: "🇷🇴", dial: "+40" },
  { name: "Sllovaki", flag: "🇸🇰", dial: "+421" },
  { name: "Slloveni", flag: "🇸🇮", dial: "+386" },
  { name: "Spanjë", flag: "🇪🇸", dial: "+34" },
  { name: "Suedi", flag: "🇸🇪", dial: "+46" },
  { name: "Zvicër", flag: "🇨🇭", dial: "+41" },
  { name: "Mbretëria e Bashkuar", flag: "🇬🇧", dial: "+44" },
  { name: "Norvegji", flag: "🇳🇴", dial: "+47" },
];

export const COUNTRY_LIST = COUNTRIES.map((c) => c.name);
export const PHONE_CODES = COUNTRIES.map((c) => ({ flag: c.flag, dial: c.dial }));

const FLAG_BY_NAME = Object.fromEntries(COUNTRIES.map((c) => [c.name, c.flag]));

// Replace lists in place with admin-managed data (keeps existing imports working)
export function applyPlaces(list) {
  if (!Array.isArray(list) || !list.length) return;
  const replace = (arr, items) => arr.splice(0, arr.length, ...items);
  replace(COUNTRIES, list.map(({ name, flag, dial }) => ({ name, flag, dial })));
  replace(COUNTRY_LIST, list.map((c) => c.name));
  replace(PHONE_CODES, list.filter((c) => c.dial).map((c) => ({ flag: c.flag, dial: c.dial })));
  Object.keys(FLAG_BY_NAME).forEach((k) => delete FLAG_BY_NAME[k]);
  list.forEach((c) => { FLAG_BY_NAME[c.name] = c.flag; });
  Object.keys(CITIES_BY_COUNTRY).forEach((k) => delete CITIES_BY_COUNTRY[k]);
  list.forEach((c) => { CITIES_BY_COUNTRY[c.name] = sortCities(c.cities || {}); });
}

export function currentPlaces() {
  return COUNTRIES.map((c) => ({ ...c, cities: { ...(CITIES_BY_COUNTRY[c.name] || {}) } }));
}
export function countryFlag(name) {
  return FLAG_BY_NAME[name] || COUNTRIES.find((c) => c.name === name)?.flag || REKLAME_COUNTRIES.find((c) => c.name === name)?.flag || "";
}
export function flagImg(name) {
  const iso = [...countryFlag(name)].map((ch) => String.fromCharCode(ch.codePointAt(0) - 0x1f1e6 + 97)).join("");
  return /^[a-z]{2}$/.test(iso) ? `https://flagcdn.com/w40/${iso}.png` : "";
}

// Profile/registration: diaspora countries + Balkan (Reklamë) countries
export function profileCountries() {
  const names = new Set(COUNTRIES.map((c) => c.name));
  return [...COUNTRIES, ...REKLAME_COUNTRIES.filter((c) => !names.has(c.name))];
}

export function profileCities(country) {
  if (!country) return [];
  const a = Object.keys(CITIES_BY_COUNTRY[country] || {});
  return a.length ? a : (REKLAME_CITIES[country] || []);
}

// Qytetet kryesore me koordinatat [lat, lng]
export const CITIES_BY_COUNTRY = {
  "Austri": { "Vjenë": [48.2082, 16.3738], "Graz": [47.0707, 15.4395], "Linz": [48.3069, 14.2858], "Salzburg": [47.8095, 13.055], "Innsbruck": [47.2692, 11.4041], "Klagenfurt": [46.6247, 14.3053], "Villach": [46.6111, 13.8558], "Wels": [48.1575, 14.0289], "Dornbirn": [47.4125, 9.7417], "Bregenz": [47.5031, 9.7471] },
  "Belgjikë": { "Bruksel": [50.8503, 4.3517], "Antwerp": [51.2194, 4.4025], "Gent": [51.0543, 3.7174], "Charleroi": [50.4108, 4.4446], "Liège": [50.6326, 5.5797], "Brugge": [51.2093, 3.2247] },
  "Bullgari": { "Sofje": [42.6977, 23.3219], "Plovdiv": [42.1354, 24.7453], "Varna": [43.2141, 27.9147] },
  "Kroaci": { "Zagreb": [45.815, 15.9819], "Split": [43.5081, 16.4402], "Rijeka": [45.3271, 14.4422], "Osijek": [45.555, 18.6955], "Zadar": [44.1194, 15.2314], "Dubrovnik": [42.6507, 18.0944] },
  "Qipro": { "Nikosia": [35.1856, 33.3823], "Limasol": [34.7071, 33.0226], "Larnaka": [34.9229, 33.6233], "Pafos": [34.772, 32.4297] },
  "Çeki": { "Pragë": [50.0755, 14.4378], "Brno": [49.1951, 16.6068], "Ostrava": [49.8209, 18.2625] },
  "Danimarkë": { "Kopenhagë": [55.6761, 12.5683], "Aarhus": [56.1629, 10.2039], "Odense": [55.4038, 10.4024], "Aalborg": [57.0488, 9.9217], "Esbjerg": [55.467, 8.4522], "Randers": [56.4607, 10.0369], "Kolding": [55.4904, 9.4722], "Vejle": [55.7111, 9.5357] },
  "Estoni": { "Tallinn": [59.437, 24.7536] },
  "Finlandë": { "Helsinki": [60.1699, 24.9384], "Espoo": [60.2055, 24.6559], "Tampere": [61.4978, 23.761], "Turku": [60.4518, 22.2666] },
  "Francë": { "Paris": [48.8566, 2.3522], "Marsejë": [43.2965, 5.3698], "Lion": [45.764, 4.8357], "Tuluzë": [43.6047, 1.4442], "Nicë": [43.7102, 7.262], "Nantes": [47.2184, -1.5536], "Strasburg": [48.5734, 7.7521], "Montpelier": [43.6108, 3.8767], "Bordo": [44.8378, -0.5792], "Lille": [50.6292, 3.0573] },
  "Gjermani": { "Berlin": [52.52, 13.405], "München": [48.1351, 11.582], "Hamburg": [53.5511, 9.9937], "Köln": [50.9375, 6.9603], "Frankfurt": [50.1109, 8.6821], "Stuttgart": [48.7758, 9.1829], "Düsseldorf": [51.2277, 6.7735], "Dortmund": [51.5136, 7.4653], "Essen": [51.4556, 7.0116], "Bremen": [53.0793, 8.8017], "Hannover": [52.3759, 9.732], "Leipzig": [51.3397, 12.3731], "Dresden": [51.0504, 13.7373], "Nürnberg": [49.4521, 11.0767], "Mannheim": [49.4875, 8.466], "Augsburg": [48.3705, 10.8978], "Karlsruhe": [49.0069, 8.4037], "Wiesbaden": [50.0782, 8.2398], "Bonn": [50.7374, 7.0982], "Ulm": [48.4011, 9.9876], "Freiburg": [47.999, 7.8421] },
  "Greqi": { "Athinë": [37.9838, 23.7275], "Selanik": [40.6401, 22.9444], "Patras": [38.2466, 21.7346], "Heraklion": [35.3387, 25.1442] },
  "Hungari": { "Budapest": [47.4979, 19.0402], "Debrecen": [47.5316, 21.6273], "Szeged": [46.253, 20.1414] },
  "Irlandë": { "Dublin": [53.3498, -6.2603], "Cork": [51.8985, -8.4756], "Limerick": [52.6638, -8.6267], "Galway": [53.2707, -9.0568] },
  "Itali": { "Romë": [41.9028, 12.4964], "Milano": [45.4642, 9.19], "Napoli": [40.8518, 14.2681], "Torino": [45.0703, 7.6869], "Firence": [43.7696, 11.2558], "Venecia": [45.4408, 12.3155], "Bolonja": [44.4949, 11.3426], "Verona": [45.4384, 10.9916], "Bari": [41.1171, 16.8719], "Palermo": [38.1157, 13.3615] },
  "Letoni": { "Riga": [56.9496, 24.1052] },
  "Lituani": { "Vilnius": [54.6872, 25.2797], "Kaunas": [54.8985, 23.9036] },
  "Luksemburg": { "Luksemburg": [49.6116, 6.1319] },
  "Maltë": { "Valletta": [35.8989, 14.5146], "Birkirkara": [35.8972, 14.4611], "Sliema": [35.9122, 14.5042], "Qormi": [35.8769, 14.4722] },
  "Holandë": { "Amsterdam": [52.3676, 4.9041], "Roterdam": [51.9244, 4.4777], "Hagë": [52.0705, 4.3007], "Utrecht": [52.0907, 5.1214], "Eindhoven": [51.4416, 5.4697], "Groningen": [53.2194, 6.5665], "Tilburg": [51.5555, 5.0913] },
  "Poloni": { "Varshavë": [52.2297, 21.0122], "Krakovë": [50.0647, 19.945], "Wrocław": [51.1079, 17.0385], "Poznań": [52.4064, 16.9252] },
  "Portugali": { "Lisbonë": [38.7223, -9.1393], "Porto": [41.1579, -8.6291], "Braga": [41.5454, -8.4265], "Coimbra": [40.2033, -8.4103] },
  "Rumani": { "Bukuresht": [44.4268, 26.1025], "Cluj": [46.7712, 23.6236], "Timișoara": [45.7489, 21.2087] },
  "Sllovaki": { "Bratislavë": [48.1486, 17.1077], "Košice": [48.7164, 21.2611] },
  "Slloveni": { "Lublanë": [46.0569, 14.5058], "Maribor": [46.5547, 15.6459], "Celje": [46.231, 15.2604], "Kranj": [46.2389, 14.3556] },
  "Spanjë": { "Madrid": [40.4168, -3.7038], "Barcelonë": [41.3851, 2.1734], "Valencia": [39.4699, -0.3763], "Sevilje": [37.3891, -5.9845], "Bilbao": [43.263, -2.935], "Malaga": [36.7213, -4.4214] },
  "Suedi": { "Stockholm": [59.3293, 18.0686], "Göteborg": [57.7089, 11.9746], "Malmö": [55.605, 13.0038], "Halmstad": [56.6745, 12.8568], "Uppsala": [59.8586, 17.6389], "Västerås": [59.6099, 16.5448], "Örebro": [59.2741, 15.2066], "Linköping": [58.4109, 15.6216], "Helsingborg": [56.0465, 12.6945], "Jönköping": [57.7815, 14.1562], "Norrköping": [58.5877, 16.1924], "Lund": [55.7047, 13.191], "Borås": [57.721, 12.9401], "Umeå": [63.8258, 20.263], "Gävle": [60.6749, 17.1413], "Södertälje": [59.1955, 17.6252], "Eskilstuna": [59.3666, 16.5077], "Karlstad": [59.4022, 13.5115], "Växjö": [56.8777, 14.8091], "Trollhättan": [58.2837, 12.2886] },
  "Zvicër": { "Zürich": [47.3769, 8.5417], "Gjenevë": [46.2044, 6.1432], "Bazel": [47.5596, 7.5886], "Bern": [46.948, 7.4474], "Lozanë": [46.5197, 6.6323], "Winterthur": [47.5, 8.7241], "Lucernë": [47.0502, 8.3093], "St. Gallen": [47.4245, 9.3767], "Lugano": [46.0037, 8.9511], "Biel": [47.1368, 7.2468], "Thun": [46.758, 7.628], "Aarau": [47.3925, 8.0442] },
  "Mbretëria e Bashkuar": { "Londër": [51.5072, -0.1276], "Birmingham": [52.4862, -1.8904], "Manchester": [53.4808, -2.2426], "Glasgow": [55.8642, -4.2518], "Liverpool": [53.4084, -2.9916], "Leeds": [53.8008, -1.5491], "Bristol": [51.4545, -2.5879], "Edinburgh": [55.9533, -3.1883] },
  "Norvegji": { "Oslo": [59.9139, 10.7522], "Bergen": [60.3913, 5.3221], "Trondheim": [63.4305, 10.3951], "Stavanger": [58.9699, 5.7331], "Drammen": [59.7439, 10.2045], "Kristiansand": [58.1599, 8.0182], "Tromsø": [69.6492, 18.9553], "Fredrikstad": [59.2181, 10.9298] },
};

const okPt = (c) => Array.isArray(c) && Number.isFinite(c[0]) && Number.isFinite(c[1]);
const myLoc = () => { try { return JSON.parse(localStorage.getItem("gs_loc")) || {}; } catch { return {}; } };
export function nearCountries(list = COUNTRIES) {
  const { country } = myLoc();
  return country ? [...list].sort((a, b) => (b.name === country) - (a.name === country)) : list;
}
export function nearCities(country, names) {
  const { coords } = myLoc();
  const m = CITIES_BY_COUNTRY[country] || {};
  if (!coords) return names;
  const d = (n) => (okPt(m[n]) ? (m[n][0] - coords.lat) ** 2 + ((m[n][1] - coords.lng) * Math.cos((coords.lat * Math.PI) / 180)) ** 2 : 1e9);
  return [...names].sort((a, b) => d(a) - d(b));
}

export function cityCoords(country, city) {
  const c = CITIES_BY_COUNTRY[country]?.[city] || REKLAME_COORDS[country]?.[city];
  return okPt(c) ? { lat: c[0], lng: c[1] } : null;
}

export function nearestCity(lat, lng) {
  let best = null, bestD = Infinity;
  for (const [country, cities] of Object.entries(CITIES_BY_COUNTRY)) {
    for (const [city, c] of Object.entries(cities)) {
      if (!okPt(c)) continue;
      const dLat = (c[0] - lat) * 111;
      const dLng = (c[1] - lng) * 111 * Math.cos((lat * Math.PI) / 180);
      const d = dLat * dLat + dLng * dLng;
      if (d < bestD) { bestD = d; best = { country, city }; }
    }
  }
  return best;
}

function countryCentroid(country) {
  const cities = CITIES_BY_COUNTRY[country];
  if (!cities) return null;
  const pts = Object.values(cities).filter(okPt);
  if (!pts.length) return null;
  const lat = pts.reduce((s, p) => s + p[0], 0) / pts.length;
  const lng = pts.reduce((s, p) => s + p[1], 0) / pts.length;
  return { lat, lng };
}

// COUNTRIES sorted: user's own country first, then nearest by distance to coords (or own country centroid)
export function countriesByProximity(userCountry, coords) {
  const list = [...COUNTRIES];
  const ref = coords || (userCountry ? countryCentroid(userCountry) : null);
  if (ref) {
    const lngK = Math.cos((ref.lat * Math.PI) / 180);
    const dist = (name) => {
      const c = countryCentroid(name);
      if (!c) return Infinity;
      const dLat = c.lat - ref.lat;
      const dLng = (c.lng - ref.lng) * lngK;
      return dLat * dLat + dLng * dLng;
    };
    list.sort((a, b) => dist(a.name) - dist(b.name));
  }
  if (userCountry) {
    const idx = list.findIndex((c) => c.name === userCountry);
    if (idx > 0) list.unshift(list.splice(idx, 1)[0]);
  }
  return list;
}

// Reklamë category — only these 4 Balkan countries (separate from the European COUNTRIES list)
export const REKLAME_COUNTRIES = [
  { name: "Kosovë", flag: "🇽🇰", dial: "+383" },
  { name: "Shqipëri", flag: "🇦🇱", dial: "+355" },
  { name: "Maqedonia e Veriut", flag: "🇲🇰", dial: "+389" },
  { name: "Mali i Zi", flag: "🇲🇪", dial: "+382" },
];

export const REKLAME_CITIES = {
  "Kosovë": ["Prishtinë", "Prizren", "Pejë", "Gjakovë", "Ferizaj", "Gjilan", "Mitrovicë", "Vushtrri", "Podujevë", "Suharekë", "Rahovec", "Malishevë", "Drenas", "Lipjan", "Kaçanik", "Deçan", "Istog", "Klinë", "Fushë Kosovë", "Obiliq", "Kamenicë", "Dragash", "Shtime", "Viti", "Skenderaj", "Junik", "Mamushë"],
  "Shqipëri": ["Tiranë", "Durrës", "Vlorë", "Shkodër", "Elbasan", "Fier", "Korçë", "Berat", "Lushnjë", "Kavajë", "Pogradec", "Gjirokastër", "Sarandë", "Lezhë", "Kukës", "Peshkopi", "Burrel", "Krujë", "Laç", "Patos", "Librazhd", "Gramsh", "Ballsh", "Fushë-Krujë", "Rrëshen", "Himarë", "Tepelenë", "Përmet", "Bulqizë"],
  "Maqedonia e Veriut": ["Shkup", "Tetovë", "Gostivar", "Kumanovë", "Manastir", "Ohër", "Strugë", "Dibër", "Kërçovë", "Veles", "Prilep", "Shtip", "Koçan", "Kavadar", "Negotinë", "Resnjë"],
  "Mali i Zi": ["Podgoricë", "Ulqin", "Tuz", "Tivar", "Plavë", "Rozhajë", "Guci", "Budva", "Kotor", "Herceg Novi", "Nikshiq", "Cetinë", "Berane", "Bijelo Polje", "Pljevlja"],
};

const REKLAME_COORDS = {};

function byName(a, b) { return a.localeCompare(b, "sq"); }
function sortCities(obj) {
  return Object.fromEntries(Object.keys(obj).sort(byName).map((k) => [k, obj[k]]));
}
Object.keys(CITIES_BY_COUNTRY).forEach((k) => { CITIES_BY_COUNTRY[k] = sortCities(CITIES_BY_COUNTRY[k]); });
Object.keys(REKLAME_CITIES).forEach((k) => { REKLAME_CITIES[k] = [...REKLAME_CITIES[k]].sort(byName); });

export function applyReklame(list) {
  if (!Array.isArray(list) || !list.length) return;
  REKLAME_COUNTRIES.splice(0, REKLAME_COUNTRIES.length, ...list.map(({ name, flag, dial }) => ({ name, flag, dial })));
  Object.keys(REKLAME_CITIES).forEach((k) => delete REKLAME_CITIES[k]);
  Object.keys(REKLAME_COORDS).forEach((k) => delete REKLAME_COORDS[k]);
  list.forEach((c) => {
    REKLAME_CITIES[c.name] = Object.keys(c.cities || {}).sort(byName);
    REKLAME_COORDS[c.name] = { ...(c.cities || {}) };
  });
}

export function currentReklame() {
  return REKLAME_COUNTRIES.map((c) => ({
    ...c,
    cities: Object.fromEntries((REKLAME_CITIES[c.name] || []).map((n) => [n, REKLAME_COORDS[c.name]?.[n] || null])),
  }));
}

export function reklameCitiesMap() {
  return Object.fromEntries(Object.entries(REKLAME_CITIES).map(([country, names]) => [
    country, Object.fromEntries(names.map((n) => [n, REKLAME_COORDS[country]?.[n] || null])),
  ]));
}
